import { INotification } from './Interfaces';

export interface INotificationState {
    notifications: Array<INotification>;
    hasUnreadNotifications: boolean;
}

export const initialNotificationState: INotificationState = {
    notifications: [],
    hasUnreadNotifications: false,
};
